export default{props:["initialvalue","trueimage","falseimage","label","invert","imagebig","labeltrue","labelfalse","imageheight"],data:function data(){return{value:!!this.initialvalue,isImageBig:!!this.imagebig,isLabelPresent:!this.label||this.label===""?false:true}},methods:{emitChange:function emitChange(){this.$emit("change",this.value)}},computed:{imageStyle:function imageStyle(){return this.imageheight?{height:this.imageheight}:null}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/CheckElement.vue
// module id = 243
// module chunks = 0